import { checkDevice } from "v-js-utils";
import lazyloader from "@pernod-ricard-global-cms/cbllazyloader";
import jsAssets from "Assets/js/modules/jsAssets";
import checkBrowserInfo from "Assets/js/modules/check-browser-info";
import siteHeader from "Assets/js/components/site-header";
import siteModal from "Assets/js/modules/modal";

checkDevice();
checkBrowserInfo();

globalThis.requestAnimationFrame(() => {
	const header = document.querySelector(".site-header");
	siteHeader({ block: header });
	lazyloader.options.assetArray = jsAssets.dynamicAssets;
	lazyloader.options.rootMargin = "100% 0px 100px 0px";
	lazyloader.options.filePath = "js/blocks/";
	lazyloader.options.debugLogMessages = false;
	lazyloader.lazyloaderInit();
  siteModal();
});

// Function to update CSS variables
function cstOnResize() {
  const doc = document.documentElement;
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  let vh = screenHeight * 0.01;

  document.documentElement.style.setProperty('--vh', `${vh}px`);
  doc.style.setProperty('--screen-height', `${window.innerHeight}px`);
  
  document.documentElement.style.setProperty('--screen-width', `${screenWidth}px`);
  document.documentElement.style.setProperty('--screen-height', `${screenHeight}px`);
}

// Initialize CSS variables.
cstOnResize();

// Load Newsletter.
loadNewsletter();

// Update CSS variables whenever the window is resized
window.addEventListener('resize', cstOnResize);


// Newsletter Functions

// Function to get the value of a cookie by name
function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
}

// Load Newsletter for new users.
function loadNewsletter() {
  const $elNewsletter = document.querySelectorAll('section.modal--newsletter'),
        modalCookie = getCookie('showNewsletterModal');

  if ($elNewsletter.length > 0 && !modalCookie) {
    $elNewsletter.forEach(($el) => {
      const $elModalContainer = $el.getElementsByClassName('modal__container--newsletter');

      setTimeout(() => {
        $el.classList.add('modal--visible');
        $elModalContainer[0].classList.add('fade-in-right');
      }, 3000);
		});
  }

}